<template>
  <div class="pagination">
    <div class="pagcontent">
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 30, 40]"
          :page-size="1" :total="alltotal" layout="total,sizes, prev, pager, next, jumper" :current-page='pageNum'>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['total', 'pageNums'],
    data() {
      return {
        alltotal: null, //总页数
        pageNum: 1, //
        Howmanybarsdata: '',
        Currentpage: '',
      }
    },
    created() {

    },
    computed: {

    },
    components: {

    },
    methods: {
      handleSizeChange(val) { //显示每页多少条数据
        this.Howmanybarsdata = val;
        this.$emit("dstdata", {
          'dst': this.Howmanybarsdata
        })
      },
      handleCurrentChange(val) { //当前页
        this.pageNum = val
        this.Currentpage = val;
        this.$emit("dsydata", {
          'dsy': this.Currentpage
        })
      }
    },
    mounted() {
      this.pageNum = this.pageNums;
    },
    watch: {
      total(newVal,oldVal) {
        this.alltotal = newVal;
      },
      pageNums(pageNums) {
        this.pageNum = pageNums;
      }
    },
  }
</script>

<style scoped>
  >>>.el-pager {
    height: 20px;

  }

  >>>.el-pager li {
    height: 20px;
    line-height: 20px;
  }
</style>
